/* @pareto-engineering/generator-front 1.1.1-alpha.1 */
import * as React from 'react'

import { useState } from 'react'
import {
  Link,
  // useLocation,
} from 'react-router-dom'

import PropTypes from 'prop-types'

import { Button } from '@pareto-engineering/design-system'

import styleNames from '@pareto-engineering/bem/exports'

import { ConversionFormButton } from 'modules/components'

import { defaultNavItems } from './common/defaultNavItems'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'navigation-bar'

/**
 * This is the component description.
 */
const NavigationBar = ({
  id,
  className:userClassName,
  style,
  items,
  overrideButtonLink,
  overrideButtonText,
  overrideButtonToScrollToId,
  // ...otherProps
}) => {
  const [isSubItemOpen, setIsSubItemOpen] = useState({
    useCases   :true,
    opsServices:false,
  })

  const [isOpen, setIsOpen] = useState(false)

  const getCtaButton = (props) => {
    if (overrideButtonLink || overrideButtonToScrollToId) {
      const target = overrideButtonToScrollToId ? '' : '_blank'
      return (
        <a
          href={overrideButtonLink || `#${overrideButtonToScrollToId}`}
          target={target}
          rel="noopener noreferrer"
          {...props}
        >
          <Button
            isGradient
            color="interactive"
          >
            {overrideButtonText || 'Get started'}
          </Button>
        </a>
      )
    }

    return (
      <ConversionFormButton
        isGradient
        color="interactive"
        {...props}
      >
        {overrideButtonText || 'Get started'}
      </ConversionFormButton>
    )
  }

  return (
    <div
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
        isOpen && 'nav-open',
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
    >
      {/* eslint-disable jsx-a11y/label-has-associated-control */}
      <input type="checkbox" id="hamburger_input" name="hamburger_input" onClick={() => setIsOpen(!isOpen)} />
      <label htmlFor="hamburger_input">
        <span />
        <span />
        <span />
      </label>
      {/* eslint-enable jsx-a11y/label-has-associated-control */}
      <nav className="span-grid grid">
        <Link to="/" className="logo-wrapper md-start-2 md-span-2">
          <p className="logo s1">
            <span className="icon">z</span>
            <strong className="name">Pareto</strong>
          </p>
        </Link>
        <ul className="content md-start-4 md-span-8">
          { items.map((item) => (
            <li className={
              [
                'item',
                'span-8',
                // item.extraClassName,
              ].filter(Boolean).join(' ')
              }
            >
              {
                item.hasSubItems ? (
                  <>
                    <Button
                      isSimple
                      color="heading"
                      onClick={() => setIsSubItemOpen({
                        ...isSubItemOpen,
                        [item.key]:!isSubItemOpen[item.key],
                      })}
                    >
                      <span>{item.title}</span>
                      <span
                        className="icon s-2"
                        style={{
                          '--icon':isSubItemOpen[item.key] ? "'W'" : "'V'",
                        }}
                      />
                    </Button>
                    {item?.subItems?.length && (
                      <ul
                        className="sub-items-wrapper"
                        style={{
                          '--display':isSubItemOpen[item.key] ? 'flex' : 'none',
                          '--rows'   :item.subItems.length <= 3 ? item.subItems.length : Math.ceil(item.subItems.length / 3),
                        }}
                      >
                        {item.subItems.map((subItem) => (
                          <li className="sub-item">
                            <Link to={subItem.link}>{subItem.title}</Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <Link to={item.link}>{ item.title }</Link>
                )
              }
            </li>
          ),
          ) }
          <li className="cta-mobile">
            {getCtaButton({})}
          </li>
        </ul>
        <div className="md-start-13 cta-desktop">
          {getCtaButton({})}
        </div>
      </nav>
    </div>
  )
}

NavigationBar.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   *  The children JSX
   */
  items:PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),

  /**
   * The link to override the button in the navigation bar
   */
  overrideButtonLink:PropTypes.string,

  /**
   * The text to override the button in the navigation bar
   */
  overrideButtonText:PropTypes.string,

  /**
   * The id to scroll to when the button is clicked
   */
  overrideButtonToScrollToId:PropTypes.string,
}

NavigationBar.defaultProps = {
  items:defaultNavItems,
}

export default NavigationBar
